import Vue from 'vue'
import Vuex from 'vuex'

import agency from '@/store/modules/agency.js'
import forms from '@/store/modules/forms.js'
import bookings from '@/store/modules/bookings.js'
import bookPath from '@/store/modules/book-path.js'
import search from '@/store/modules/search'
import users from "@/store/modules/users";
import { vuexfireMutations } from 'vuexfire'

Vue.use(Vuex);

export const store = new Vuex.Store ({
  mutations: { ...vuexfireMutations, },
  modules: {
    namespaced: true,
    agency,
    bookings,
    forms,
    bookPath,
    search,
    users
  }
});